import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from '../../core/services/logger.service';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

/**
 * Landing page for the Stripe Checkout `success_url`/`cancel_url` redirect
 * from the signup wizard's paid-plan handoff (see signup.component.ts).
 *
 * The org itself was already created (on Free) before Checkout ever started,
 * so both outcomes here just continue into the app -- the plan upgrade takes
 * effect asynchronously via the Stripe webhook, not this page.
 */
@Component({
  selector: 'app-signup-complete',
  standalone: true,
  imports: [ButtonComponent, CardComponent, IconComponent, TranslatePipe],
  templateUrl: './signup-complete.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './signup-complete.component.css',
})
export class SignupCompleteComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private logger = inject(LoggerService).getLogger('signup-complete');

  outcome = signal<'success' | 'cancelled'>('success');

  ngOnInit(): void {
    const checkout = this.route.snapshot.queryParamMap.get('checkout');
    this.outcome.set(checkout === 'cancelled' ? 'cancelled' : 'success');
    this.logger.debug('Checkout redirect landed:', { checkout });

    setTimeout(() => this.continue(), 3000);
  }

  continue(): void {
    this.router.navigate(['/']);
  }
}
